import { Backdrop, Spinner } from '@cencosud-cencommerce/paris-uikit';

export const LoadingSpinner = ({ showSpinner }: { showSpinner: boolean }) => {
  if (!showSpinner) return null;

  return (
    <>
      <Backdrop className="co-bg-white co-opacity-40" show={showSpinner} />
      <div
        className="co-fixed co-left-0 co-top-0 co-h-full co-w-full co-flex co-justify-center co-items-center co-z-50"
        role="status"
        aria-live="polite"
      >
        <Spinner />
        <span className="co-sr-only">Cargando...</span>
      </div>
    </>
  );
};

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
